module.exports = __webpack_public_path__ + "static/media/Notes.aad54323.png";